module.exports = __webpack_public_path__ + "img/Img6_204463_KcFr-3-1507.9685943c.jpg";